import { Box } from "@mui/material";
import SimpleEdit from "../../SimpleEdit";

export default function BasicDataTab({
  projectData,
  clearAllFields,
  client,
  isDisabled,
  setDisabled,
  initializeLoadingToast,
  updateLoadingToast,
  addressController,
  attorneyController,
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SimpleEdit
        projectData={projectData}
        clearAllFields={clearAllFields}
        client={client}
        isDisabled={isDisabled}
        setDisabled={setDisabled}
        initializeLoadingToast={initializeLoadingToast}
        updateLoadingToast={updateLoadingToast}
        addressController={addressController}
        attorneyController={attorneyController}
      />
    </Box>
  );
}
